export default "__VITE_ASSET__cd7f49c7__"